
import React, { createContext, useContext, useMemo, useReducer, useState } from 'react'
import PropTypes from 'prop-types'

import sideBar6 from '../assets/utils/images/sidebar/city1.jpg'

const ThemeContext = createContext(null)

function reducer(state, action)
{
	switch (action.type)
	{
		case 'BACKGROUND_COLOR':
		{
			return { ...state, backgroundColor: action.value }
		}
		case 'HEADER_BACKGROUND_COLOR':
		{
			return { ...state, headerBackgroundColor: action.value }
		}
		case 'ENABLE_MOBILE_MENU_SMALL':
		{
			return { ...state, enableMobileMenuSmall: action.value }
		}
		case 'ENABLE_BACKGROUND_IMAGE':
		{
			return { ...state, enableBackgroundImage: action.value }
		}
		case 'ENABLE_CLOSED_SIDEBAR':
		{
			return { ...state, enableClosedSidebar: action.value }
		}
		case 'ENABLE_FIXED_HEADER':
		{
			return { ...state, enableFixedHeader: action.value }
		}
		case 'ENABLE_HEADER_SHADOW':
		{
			return { ...state, enableHeaderShadow: action.value}
		}
		case 'ENABLE_SIDEBAR_SHADOW':
		{
			return { ...state, enableSidebarShadow: action.value }
		}
		case 'ENABLE_FIXED_FOOTER':
		{
			return { ...state, enableFixedFooter: action.value }
		}
		case 'ENABLE_FIXED_SIDEBAR':
		{
			return { ...state, enableFixedSidebar: action.value }
		}
		case 'COLOR_SCHEME':
		{
			return { ...state, colorScheme: action.value }
		}
		case 'BACKGROUND_IMAGE':
		{
			return { ...state, backgroundImage: action.value }
		}
		case 'BACKGROUND_IMAGE_OPACITY':
		{
			return { ...state, backgroundImageOpacity: action.value }
		}
		case 'ENABLE_PAGE_TITLE_ICON':
		{
			return { ...state, enablePageTitleIcon: action.value }
		}
		case 'ENABLE_PAGE_TITLE_SUBHEADING':
		{
			return { ...state, enablePageTitleSubheading: action.value }
		}
		case 'ENABLE_PAGE_TABS_ALT':
		{
			return { ...state, enablePageTabsAlt: action.value }
		}
		case 'ENABLE_MOBILE_MENU':
		{
			return { ...state, enableMobileMenu: action.value }
		}
	}
}

function useThemeContext()
{
	return useContext(ThemeContext)
}

const ThemeProvider = ({ children }) =>
{
	const initialState =
		{
			backgroundColor: '',
			headerBackgroundColor: '',
			enableMobileMenu: true,
			enableMobileMenuSmall: '',
			enableBackgroundImage: false,
			enableClosedSidebar: false,
			enableFixedHeader: true,
			enableHeaderShadow: true,
			enableSidebarShadow: true,
			enableFixedFooter: true,
			enableFixedSidebar: true,
			colorScheme: 'white',
			backgroundImage: sideBar6,
			backgroundImageOpacity: 'opacity-06',
			enablePageTitleIcon: true,
			enablePageTitleSubheading: true,
			enablePageTabsAlt: true,
		}
	
	const [controller, dispatch] = useReducer(reducer, initialState)
	const value = useMemo(() => [controller, dispatch], [controller, dispatch])
	
	return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

const setBackgroundColor = (dispatch, value) => dispatch({ type: 'BACKGROUND_COLOR', value })
const setHeaderBackgroundColor = (dispatch, value) => dispatch({ type: 'HEADER_BACKGROUND_COLOR', value })
const setEnableMobileMenuSmall = (dispatch, value) => dispatch({ type: 'ENABLE_MOBILE_MENU_SMALL', value })
const setEnableBackgroundImage = (dispatch, value) => dispatch({ type: 'ENABLE_BACKGROUND_IMAGE', value })
const setEnableClosedSidebar = (dispatch, value) => dispatch({ type: 'ENABLE_CLOSED_SIDEBAR', value })
const setEnableFixedHeader = (dispatch, value) => dispatch({ type: 'ENABLE_FIXED_HEADER', value })
const setEnableHeaderShadow = (dispatch, value) => dispatch({ type: 'ENABLE_HEADER_SHADOW', value })
const setEnableSidebarShadow = (dispatch, value) => dispatch({ type: 'ENABLE_SIDEBAR_SHADOW', value })
const setEnableFixedFooter = (dispatch, value) => dispatch({ type: 'ENABLE_FIXED_FOOTER', value })
const setEnableFixedSidebar = (dispatch, value) => dispatch({ type: 'ENABLE_FIXED_SIDEBAR', value })
const setColorScheme = (dispatch, value) => dispatch({ type: 'COLOR_SCHEME', value })
const setBackgroundImage = (dispatch, value) => dispatch({ type: 'BACKGROUND_IMAGE', value })
const setBackgroundImageOpacity = (dispatch, value) => dispatch({ type: 'BACKGROUND_IMAGE_OPACITY', value })
const setEnablePageTitleIcon = (dispatch, value) => dispatch({ type: 'ENABLE_PAGE_TITLE_ICON', value })
const setEnablePageTitleSubheading = (dispatch, value) => dispatch({ type: 'ENABLE_PAGE_TITLE_SUBHEADING', value })
const setEnablePageTabsAlt = (dispatch, value) => dispatch({ type: 'ENABLE_PAGE_TABS_ALT', value })
const setEnableMobileMenu = (dispatch, value) => dispatch({ type: 'ENABLE_MOBILE_MENU', value })

export
{
	ThemeProvider,
	useThemeContext,
	setBackgroundColor,
	setHeaderBackgroundColor,
	setEnableMobileMenuSmall,
	setEnableBackgroundImage,
	setEnableClosedSidebar,
	setEnableFixedHeader,
	setEnableHeaderShadow,
	setEnableSidebarShadow,
	setEnableFixedFooter,
	setEnableFixedSidebar,
	setColorScheme,
	setBackgroundImage,
	setBackgroundImageOpacity,
	setEnablePageTitleIcon,
	setEnablePageTitleSubheading,
	setEnablePageTabsAlt,
	setEnableMobileMenu
}
